import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer'; // Import the new Footer component
import HeroSection from './components/HeroSection';
import JourneyTimeline from './components/JourneyTimeline';
import PhilosophySection from './components/PhilosophySection';
import DayInLifeSection from './components/DayInLifeSection';
import SkillsShowcase from './components/SkillsShowcase';
import VisionSection from './components/VisionSection';
import Button from '../../components/ui/Button'; // Import the Button component for consistency

const AboutJourneyPhilosophy = () => {
  return (
    <>
      <Helmet>
        <title>Ebesoh Adrian - My Journey & Philosophy | Adrian Portfolio</title>
        <meta
          name="description"
          content="Learn about Ebesoh Adrian's journey as a developer, his philosophy on mentorship and community, and his vision for the future of tech. Discover the story behind the code."
        />
        <meta name="keywords" content="Adrian, about me, developer journey, mentorship philosophy, community building, tech vision, personal story" />
        <meta property="og:title" content="About - My Journey & Philosophy | Adrian Portfolio" />
        <meta property="og:description" content="A deep dive into Adrian's background, his passion for community, and his approach to building both software and careers." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://ebesohadrian.netlify.app/aboutpage" />
        <link rel="canonical" href="https://ebesohadrian.netlify.app/aboutpage" />
      </Helmet>
      <div className="min-h-screen bg-background">
        <Header />

        {/* This main container adds top padding to prevent content from hiding under the fixed header */}
        <main className="pt-24 lg:pt-28">
          <HeroSection />
          <JourneyTimeline />
          <PhilosophySection />
          <DayInLifeSection />
          <SkillsShowcase />
          <VisionSection />
          
          {/* Footer CTA Section */}
          <section className="py-16 bg-gradient-to-r from-primary to-accent">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4">
                Ready to Start Your Journey?
              </h2>
              <p className="text-sm md:text-base lg:text-lg text-white/90 mb-8 max-w-2xl mx-auto">
                Let's build something amazing together and create impact that matters.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button
                  variant="light"
                  size="lg"
                  onClick={() => window.location.href = '/contactpage'}
                  className="w-full sm:w-auto px-8 py-3 bg-white text-primary font-semibold rounded-lg hover:bg-gray-100 transition-colors duration-300"
                >
                  Start a Project
                </Button>
                <Button
                  variant="outline"
                  size="lg"
                  onClick={() => window.location.href = '/servicespage'}
                  className="w-full sm:w-auto border-2 border-white text-white font-semibold rounded-lg hover:bg-white hover:text-primary transition-colors duration-300"
                >
                  Explore Services
                </Button>
              </div>
            </div>
          </section>
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </>
  );
};

export default AboutJourneyPhilosophy;